import * as moment from "moment";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { InitializePolling } from "source/app/presentation/Header/Center/Sync/Helpers/InitializePolling";
import { SynchronizeAsync } from "source/app/presentation/Header/Center/Sync/Helpers/Synchronize";
import { SetState } from "source/app/services/UI/State/SetState";
import { IUserDTO } from "../../../../../../../motw_core/DTOs/IUserDTO";
import { EUserClaim } from "../../../../../../../motw_core/Enums/EUserClaim";
import { ShareState } from "../../../../services/UI/State/ShareState";
import { ISyncNotificationState } from "./ISyncNotificationState";
import { State } from "../../../../services/UI/State/State";

export function SyncNotification() {
    const [state, setState] = React.useState<ISyncNotificationState>({
        lastLoadAllTime: moment().format(),
        syncNotificationElement: <span />,
        userDto: undefined,
        isOutOfSync: false,
    });

    ShareState(ESharedFunction.SyncNotification_state, state, setState);

    React.useEffect(() => {
        HandleUserClaims(state.userDto);
    }, [state.userDto?.claims]);

    React.useEffect(() => {
        let stopPolling: (() => void) | undefined;
        const timeout = window.setTimeout(() => {
            stopPolling = InitializePolling();
        }, 5000);
        return () => {
            window.clearTimeout(timeout);
            stopPolling?.();
        };
    }, []);

    React.useEffect(() => {
        SynchronizeAsync(state);
    }, [state.lastLoadAllTime, state.userDto]);

    return (
        <span>
            {state.syncNotificationElement}
        </span>
    );
}

function HandleUserClaims(userDto: IUserDTO | undefined) {
    if (userDto?.claims.includes(EUserClaim[EUserClaim.mode_desktop])) {
        SetState(ESharedFunction.ToggleDeviceMode_isDesktopModeAllowed, true);
    }
}
